import { DocumentTypeCat } from '@ps/platform-message-framework/common/DocumentTypeCat';
import { Sites } from '@ps/platform-message-framework/common/Sites';
import type { TrackedTranslation } from '@ps/web-core-intl';
import { select } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import React from 'react';
import { useSelector } from 'react-redux';

import { Country } from '@swf/core/enums';

import { DocumentTypeCatPortugal } from '../../../../../../types/Cashier';
import RMFDropDown from '../../../RMFDropDown/RMFDropDown';

import {
  TXTCLI_DriverXs_License,
  TXTCLI_National_Identity_Card,
  TXTCLI_Other__choice,
  TXTCLI_Passport,
  TXTWCL_Document_type,
  TXTWCL_Please_choose_document_type,
  TXTWCL_Residence_Card,
  TXTWCL_Select_document_type
} from './DocumentTypeField.messages.json';
import { wrapper } from './DocumentTypeField.scss';

export const docTypeField = 'docType';

interface Props {
  country?: string;
  citizenship?: string;
  className?: string;
  label?: TrackedTranslation;
}

const getOptions = (
  siteId: number,
  country: string | undefined,
  citizenship: string | undefined
) => {
  switch (siteId) {
    case Sites.POR:
      return [
        { text: <Translation {...TXTCLI_Passport} />, value: DocumentTypeCatPortugal.PASSPORT },
        {
          text: <Translation {...TXTCLI_DriverXs_License} />,
          value: DocumentTypeCatPortugal.DRIVERS_LICENSE
        },
        { text: <Translation {...TXTCLI_Other__choice} />, value: DocumentTypeCatPortugal.OTHER }
      ];
    case Sites.DEN:
    case Sites.GR:
      return [
        {
          text: <Translation {...TXTCLI_National_Identity_Card} />,
          value: DocumentTypeCat.NATIONAL_IDENTITY_CARD
        },

        { text: <Translation {...TXTCLI_Passport} />, value: DocumentTypeCat.PASSPORT }
      ];
    case Sites.SPA:
      if (country !== Country.Spain && citizenship !== Country.Spain) {
        return [
          { text: <Translation {...TXTCLI_Passport} />, value: DocumentTypeCat.PASSPORT },
          { text: <Translation {...TXTCLI_Other__choice} />, value: DocumentTypeCat.OTHER }
        ];
      }
      if (citizenship !== Country.Spain) {
        return [
          {
            text: <Translation {...TXTWCL_Residence_Card} />,
            value: DocumentTypeCat.NATIONAL_IDENTITY_CARD
          }
        ];
      }
      return [
        {
          text: <Translation {...TXTCLI_National_Identity_Card} />,
          value: DocumentTypeCat.NATIONAL_IDENTITY_CARD
        }
      ];

    default:
      return [
        {
          text: <Translation {...TXTCLI_National_Identity_Card} />,
          value: DocumentTypeCat.NATIONAL_IDENTITY_CARD
        },
        {
          text: <Translation {...TXTCLI_DriverXs_License} />,
          value: DocumentTypeCat.DRIVERS_LICENSE
        },
        { text: <Translation {...TXTCLI_Passport} />, value: DocumentTypeCat.PASSPORT }
      ];
  }
};

const DocumentTypeField: React.FC<Props> = ({
  country,
  citizenship,
  label = TXTWCL_Document_type
}) => {
  const siteId = useSelector(select.cms.getSiteId);
  const isSpain = siteId === Sites.SPA;

  const disabled = isSpain && (country === Country.Spain || citizenship === Country.Spain);
  const options = getOptions(siteId, country, citizenship);

  return (
    <RMFDropDown
      id={docTypeField}
      label={label}
      options={options}
      validators={[required(TXTWCL_Please_choose_document_type)]}
      className={wrapper}
      disabled={disabled}
      placeholder={<Translation {...TXTWCL_Select_document_type} />}
    />
  );
};

export default DocumentTypeField;
